import {createSelector} from '@reduxjs/toolkit';
import {System} from 'common/models/system';

import selectSystem from './selectSystem';

const selectError: (system: System) => System['error'] = (system) => system.error;

export default createSelector(selectSystem, selectError);
